import React, { useContext, useEffect, useState } from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';

import ObjectsContext from '~/containers/ObjectManager/ObjectsContext';
import IncidentArtifactTable from '~/containers/IncidentArtifactTable/IncidentArtifactTable';
import Loader from '~/components/Loader/Loader';

const propTypes = {
    artifactItems: PropTypes.array,
    addArtifactItem: PropTypes.func.isRequired,
    removeArtifactItem: PropTypes.func.isRequired,
    updateArtifactItem: PropTypes.func.isRequired,
    validationSchema: PropTypes.object.isRequired
};

const defaultProps = {
    artifactItems: []
};

function IncidentArtifactCreationTable({
    artifactItems,
    addArtifactItem,
    removeArtifactItem,
    updateArtifactItem,
    validationSchema
}) {
    const objectsContext = useContext(ObjectsContext);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        objectsContext.getCefFields().then(() => {
            setIsLoading(false);
        });
    }, []);

    if (isLoading)
        return (
            <div className="artifact-creation-wrapper">
                <Loader />
            </div>
        );

    return (
        <div className="artifact-creation-wrapper">
            <Formik
                initialValues={{}}
                validationSchema={validationSchema}
                onSubmit={() => {}}
            >
                {formProps => (
                    <IncidentArtifactTable
                        artifactItems={artifactItems}
                        addArtifactItem={addArtifactItem}
                        removeArtifactItem={removeArtifactItem}
                        updateArtifactItem={updateArtifactItem}
                        cefFields={objectsContext.cefFields}
                        formProps={formProps}
                    />
                )}
            </Formik>
        </div>
    );
}

IncidentArtifactCreationTable.propTypes = propTypes;
IncidentArtifactCreationTable.defaultProps = defaultProps;

export default IncidentArtifactCreationTable;
